<template>
  <svg
    class=""
    :width="chartWidth"
    :height="chartHeight"
    :viewBox.camel="viewBox"
    v-bind="chartBind"
  >
    <g
      class="Chart-grid"
      :key="`${keyPrefix}:${display.id}`"
      style="user-select: none"
    >
      <g :id="gridKey"></g>
    </g>

    <g class="Chart-content" v-if="layers.length">
      <g
        v-for="layer in layers"
        :key="`${keyPrefix}:${layer.id}`"
        class="Chart-layer"
        :zIndex="layer.zIndex"
      >
        <component
          :is="`datalas-${layer.type}`"
          v-bind="layer"
          :fields="fields"
          :chart-data="data"
          :chart-width="chartWidth"
          :chart-height="chartHeight"
          :is-mobile-width="isMobileWidth"
          :transforms="processedTranformers"
          :context="display"
          :grid-key="gridKey"
          :grid-mounted="gridMounted"
          @datum:mouseover="$emit('datum:mouseover', $event)"
          @datum:mouseout="$emit('datum:mouseout', $event)"
          @datum:click="$emit('datum:click', $event)"
        />
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { v4 as uuid } from 'uuid';

import identity from '../../lib/transforms/identity';
import band from '../../lib/transforms/band';
import point from '../../lib/transforms/point';
import continuous from '../../lib/transforms/continuous';
import categorical from '../../lib/transforms/categorical';
import scheme from '../../lib/transforms/scheme';
import FlexibleBars from '../layers/flexible-bars.vue';
import FlexibleArea from '../layers/flexible-area.vue';

const transforms = {
  identity,
  band,
  point,
  continuous,
  categorical,
  scheme,
};

export default {
  name: 'DatalasChart',

  inheritAttrs: false,

  components: {
    'datalas-flexible-bars': FlexibleBars,
    'datalas-flexible-area': FlexibleArea,
  },

  emits: ['datum:mouseover', 'datum:mouseout', 'datum:click'],

  props: {
    config: {
      type: Object,
      default: () => ({}),
    },

    height: {
      type: Number,
    },
    width: {
      type: Number,
    },
    isMobileWidth: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    transforms: {
      type: Array,
      default: () => [],
    },
    display: {
      type: Object,
      default: () => ({}),
    },
    children: {
      type: Array,
      default: null,
    },
    keyPrefix: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    gridKey: 'grid',
    gridMounted: false,
  }),

  computed: {
    chartWidth() {
      return this.width || this.config.width;
    },
    chartHeight() {
      return this.height || this.config.height;
    },
    viewBox() {
      const viewBox = `0 0 ${this.chartWidth} ${this.chartHeight}`;
      return this.config.scale === 'relative' && viewBox;
    },
    processedTranformers() {
      return this.transforms
        .map((t) => transforms[t.type](t))
        .reduce((acc, t) => Object.assign(acc, { [t.id]: t }), {});
    },
    layers() {
      return this.children || [this.display];
    },
    chartBind() {
      const getStylesForChart = () => {
        const styles = { height: '100%' };
        if (this.config.skin === 'gustavo') {
          if (this.display.subtype === 'row') styles.width = '100%';
        } else {
          styles.width = this.config.scale === 'relative' ? '100%' : '';
        }
        return styles;
      };

      return { style: getStylesForChart() };
    },
  },

  created() {
    this.gridKey = `grid-${uuid()}`;
  },

  mounted() {
    this.gridMounted = true;
  },
};
</script>
